/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} CheckoutInputs */

const en_checkout = /** @type {(inputs: CheckoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checkout`)
};

const th_checkout = /** @type {(inputs: CheckoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ชำระเงิน`)
};

const ja_checkout = /** @type {(inputs: CheckoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レジに進む`)
};

const fr_checkout = /** @type {(inputs: CheckoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paiement`)
};

const es_checkout = /** @type {(inputs: CheckoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finalizar compra`)
};

const ru_checkout = /** @type {(inputs: CheckoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оформить заказ`)
};

const zh_checkout = /** @type {(inputs: CheckoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`结账`)
};

const vi_checkout = /** @type {(inputs: CheckoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thanh toán`)
};

/**
* | output |
* | --- |
* | "Checkout" |
*
* @param {CheckoutInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const checkout = /** @type {((inputs?: CheckoutInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<CheckoutInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_checkout(inputs)
	if (locale === "ja") return ja_checkout(inputs)
	if (locale === "fr") return fr_checkout(inputs)
	if (locale === "es") return es_checkout(inputs)
	if (locale === "ru") return ru_checkout(inputs)
	if (locale === "zh") return zh_checkout(inputs)
	if (locale === "vi") return vi_checkout(inputs)
	return en_checkout(inputs)
});